// extracted by mini-css-extract-plugin
module.exports = {"heading":"Register_heading__3LkS_","form":"Register_form__3-tVh"};